/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B100180 WH単価マスタメンテ
 */
import { Column } from "@material-table/core";
import { Box } from "@mui/material";
import { catchRestError } from "clients/rest";
import {
  B100180Create,
  B100180CreateMeiRequest,
  B100180CreateRequest,
  B100180Delete,
  B100180DeleteMeiRequest,
  B100180DeleteRequest,
  B100180Find,
  B100180FindRequest,
  B100180Update,
  B100180UpdateMeiRequest,
  B100180UpdateRequest,
} from "clients/rest/b100/B100180";
import {
  msgState,
  SCancelButton,
  SCodeSelect,
  SConfirmDialog,
  SFileButton,
  SFrame,
  SLabel,
  SNormalButton,
  SNumberField,
  STable,
  SText,
  STextField,
} from "components";
import { getClientMessage } from "messages";
import {
  B100180Mode,
  B100180WhTankaKbn,
  getSCode,
  SCode,
} from "messages/codes";
import { labels } from "messages/labels";
import { B000111, B000111Props } from "pages";
import { createRef, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { mapIds } from "services";
import { meishoKbn } from "services/codes";
import { focusState, navigateTypeState, useFocus } from "states";

// 呼び出し時のプロパティ
type Props = Partial<{
  // 呼び出し元へデータを送る場合に設定する。
}>;

// コンポーネントで設定されるフィールドの型を定義する
// ヘッダ部
type Fields = Partial<{
  modeKbn: SCode;
  whtankaKbn: SCode;
  whtankaCd: string;
  whtankaNm: string;
  sanshoWhtankaCd: string;
  sanshoWhtankaNm: string;
  dirtyFields: {
    whtankaCd: string;
    sanshoWhtankaCd: string;
  };
}>;

// タブ部
type TabFields = Partial<{
  height: string;
  width1: string;
  width2: string;
  width3: string;
  width4: string;
  width5: string;
  width6: string;
  width7: string;
  width8: string;
  width9: string;
  width10: string;
  width11: string;
  width12: string;
  width13: string;
  width14: string;
  width15: string;
  width16: string;
  width17: string;
  width18: string;
  width19: string;
  width20: string;
  width21: string;
  width22: string;
  width23: string;
  width24: string;
  width25: string;
  width26: string;
  width27: string;
  width28: string;
  width29: string;
  width30: string;
  width31: string;
  width32: string;
  width33: string;
  width34: string;
  width35: string;
  width36: string;
  width37: string;
  width38: string;
  width39: string;
  width40: string;
  width41: string;
  width42: string;
  width43: string;
  width44: string;
  width45: string;
  width46: string;
  width47: string;
  width48: string;
  width49: string;
  version: string;
}>;

//テーブルデータの定義
type Data = Partial<{
  gyoNo: number;
  height: string;
  width1: string;
  width2: string;
  width3: string;
  width4: string;
  width5: string;
  width6: string;
  width7: string;
  width8: string;
  width9: string;
  width10: string;
  width11: string;
  width12: string;
  width13: string;
  width14: string;
  width15: string;
  width16: string;
  width17: string;
  width18: string;
  width19: string;
  width20: string;
  width21: string;
  width22: string;
  width23: string;
  width24: string;
  width25: string;
  width26: string;
  width27: string;
  width28: string;
  width29: string;
  width30: string;
  width31: string;
  width32: string;
  width33: string;
  width34: string;
  width35: string;
  width36: string;
  width37: string;
  width38: string;
  width39: string;
  width40: string;
  width41: string;
  width42: string;
  width43: string;
  width44: string;
  width45: string;
  width46: string;
  width47: string;
  width48: string;
  width49: string;
  version: string;
}>;

// 固定値
const focusId = "B100180";
// 新規モード
const modeNew = "0";
// 修正モード
const modeEdit = "1";
// WH単価
const whtankaKbnTanka = "0";
// WH原単価
const whtankaKbnGenka = "1";

// フィールドの初期値を設定する。
// ヘッダ部
const defaultFields: Fields = {
  modeKbn: getSCode(B100180Mode, modeNew),
  whtankaKbn: getSCode(B100180WhTankaKbn, "0"),
  whtankaCd: "",
  whtankaNm: "",
  sanshoWhtankaCd: "",
  sanshoWhtankaNm: "",
  dirtyFields: {
    whtankaCd: "",
    sanshoWhtankaCd: "",
  },
};

// タブ部
const defaultTabFields: TabFields = {
  height: "",
  width1: "",
  width2: "",
  width3: "",
  width4: "",
  width5: "",
  width6: "",
  width7: "",
  width8: "",
  width9: "",
  width10: "",
  width11: "",
  width12: "",
  width13: "",
  width14: "",
  width15: "",
  width16: "",
  width17: "",
  width18: "",
  width19: "",
  width20: "",
  width21: "",
  width22: "",
  width23: "",
  width24: "",
  width25: "",
  width26: "",
  width27: "",
  width28: "",
  width29: "",
  width30: "",
  width31: "",
  width32: "",
  width33: "",
  width34: "",
  width35: "",
  width36: "",
  width37: "",
  width38: "",
  width39: "",
  width40: "",
  width41: "",
  width42: "",
  width43: "",
  width44: "",
  width45: "",
  width46: "",
  width47: "",
  width48: "",
  width49: "",
  version: "",
};

// B100180 WH単価マスタメンテ
export const B100180 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

const Page = (props: Props) => {
  // 状態管理の初期設定
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });
  // フォーム関数
  const tabMethods = useForm<TabFields>({
    mode: "onBlur",
    defaultValues: defaultTabFields,
  });

  // dirtyFields初期化
  const resetDirtyFields = () => {
    const fields = methods.getValues();
    methods.setValue("dirtyFields.whtankaCd", fields.whtankaCd ?? "");
    methods.setValue(
      "dirtyFields.sanshoWhtankaCd",
      fields.sanshoWhtankaCd ?? ""
    );
  };

  // テーブル管理
  const tableRef = createRef();
  // テーブル行で選択されたデータ
  const [rowData, setRowData] = useState<Partial<Data>>();
  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));
  // 遷移元データ取得用
  const navigate = useNavigate();
  // エラー表示
  const setMsg = useSetRecoilState(msgState);
  // 画面遷移の処理
  const [menuNavigate, setMenuNavigate] = useRecoilState(navigateTypeState);

  // 新規モードかどうか
  const isNew = () => methods.getValues().modeKbn?.value === "0";
  // 更新モードかどうか
  const isEdit = () => methods.getValues().modeKbn?.value === "1";
  // 削除モードかどうか
  const isDel = () => methods.getValues().modeKbn?.value === "2";

  const [rows, setRows] = useState<Data[]>([]);

  // ページサイズ
  const pageSize = 49;
  // テーブルを定義する。
  const columns: Column<Data>[] = [
    {
      field: "gyoNo",
      title: "行　",
      width: "3rem",
      align: "right",
    },
    {
      field: "height",
      title: "高さ ＼ 幅　",
      width: "4rem",
      align: "right",
    },
    {
      field: "width1",
      title: "100　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width2",
      title: "150　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width3",
      title: "200　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width4",
      title: "250　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width5",
      title: "300　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width6",
      title: "350　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width7",
      title: "400　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width8",
      title: "450　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width9",
      title: "500　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width10",
      title: "550　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width11",
      title: "600　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width12",
      title: "650　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width13",
      title: "700　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width14",
      title: "750　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width15",
      title: "800　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width16",
      title: "850　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width17",
      title: "900　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width18",
      title: "950　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width19",
      title: "1000　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width20",
      title: "1050　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width21",
      title: "1100　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width22",
      title: "1150　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width23",
      title: "1200　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width24",
      title: "1250　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width25",
      title: "1300　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width26",
      title: "1350　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width27",
      title: "1400　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width28",
      title: "1450　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width29",
      title: "1500　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width30",
      title: "1550　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width31",
      title: "1600　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width32",
      title: "1650　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width33",
      title: "1700　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width34",
      title: "1750　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width35",
      title: "1800　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width36",
      title: "1850　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width37",
      title: "1900　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width38",
      title: "1950　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width39",
      title: "2000　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width40",
      title: "2050　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width41",
      title: "2100　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width42",
      title: "2150　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width43",
      title: "2200　",
      width: "5rem",
      align: "right",
    },

    {
      field: "width44",
      title: "2250　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width45",
      title: "2300　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width46",
      title: "2350　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width47",
      title: "2400　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width48",
      title: "2450　",
      width: "5rem",
      align: "right",
    },
    {
      field: "width49",
      title: "2500　",
      width: "5rem",
      align: "right",
    },
    { field: "version", hidden: true },
  ];

  // 再レンダリング用フラグ
  const [reRender, setReRender] = useState(false);
  const reRendering = () => {
    resetDirtyFields();
    setReRender(!reRender);
  };

  // 初期表示イベント
  useEffect(() => {
    focus(1);
  }, []);

  // モード変更時
  const handleChangeModeKbn = () => {
    // フォームのデータを取得する。
    const fields = methods.getValues();
    // 修正の場合
    if (fields.modeKbn?.value === modeEdit) {
      methods.reset();
      tabMethods.reset();
      methods.setValue("modeKbn", getSCode(B100180Mode, "1"));
    }
    // 削除の場合
    else if (fields.modeKbn?.value === "2") {
      methods.reset();
      tabMethods.reset();
      methods.setValue("modeKbn", getSCode(B100180Mode, "2"));
    }
    // 新規の場合
    else {
      methods.reset();
      tabMethods.reset();
    }

    setRows([]);
    reRendering();
  };

  // 検索
  const handleFind = () => {
    // 検索フォームのデータを取得する。
    const fields = methods.getValues();

    // 検索パラメータを作成する。
    const param: B100180FindRequest = {
      modeKbn: fields.modeKbn?.value!,
      whtankaKbn: fields.whtankaKbn?.value!,
      whtankaCd: fields.whtankaCd!,
    };

    // API呼び出し
    B100180Find(param)
      // 正常取得時
      .then((value) => {
        // 名称の設定
        methods.setValue("whtankaNm", value.data[0].whtankaNm);

        // テーブルに反映
        setRows(mapIds(value.data, "gyoNo"));
      })
      // エラー時
      .catch((reason) => {
        methods.setValue("whtankaNm", "");
        setRows([]);
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 参照での検索
  const handleFindSansho = () => {
    // 検索フォームのデータを取得する。
    const fields = methods.getValues();

    // 検索パラメータを作成する。
    const param: B100180FindRequest = {
      // 修正モードを設定する
      modeKbn: modeEdit,
      whtankaKbn: fields.whtankaKbn?.value!,
      whtankaCd: fields.sanshoWhtankaCd!,
    };

    // API呼び出し
    B100180Find(param)
      // 正常取得時
      .then((value) => {
        // 名称の設定
        methods.setValue("sanshoWhtankaNm", value.data[0].whtankaNm);
        // テーブルに反映
        setRows(mapIds(value.data, "gyoNo"));
      })
      // エラー時
      .catch((reason) => {
        methods.setValue("sanshoWhtankaNm", "");
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 登録
  const handleClickCreateButton = () => {
    const fields = methods.getValues();

    // requestの作成
    const b100180CreateFieldList = rows.map<B100180CreateMeiRequest>(
      (value) => {
        const data: B100180CreateMeiRequest = {
          height: value.height!,
          width1: value.width1,
          width2: value.width2,
          width3: value.width3,
          width4: value.width4,
          width5: value.width5,
          width6: value.width6,
          width7: value.width7,
          width8: value.width8,
          width9: value.width9,
          width10: value.width10,
          width11: value.width11,
          width12: value.width12,
          width13: value.width13,
          width14: value.width14,
          width15: value.width15,
          width16: value.width16,
          width17: value.width17,
          width18: value.width18,
          width19: value.width19,
          width20: value.width20,
          width21: value.width21,
          width22: value.width22,
          width23: value.width23,
          width24: value.width24,
          width25: value.width25,
          width26: value.width26,
          width27: value.width27,
          width28: value.width28,
          width29: value.width29,
          width30: value.width30,
          width31: value.width31,
          width32: value.width32,
          width33: value.width33,
          width34: value.width34,
          width35: value.width35,
          width36: value.width36,
          width37: value.width37,
          width38: value.width38,
          width39: value.width39,
          width40: value.width40,
          width41: value.width41,
          width42: value.width42,
          width43: value.width43,
          width44: value.width44,
          width45: value.width45,
          width46: value.width46,
          width47: value.width47,
          width48: value.width48,
          width49: value.width49,
        };
        return data;
      }
    );
    const param: B100180CreateRequest = {
      whtankaKbn: fields.whtankaKbn?.value!,
      whtankaCd: fields.whtankaCd!,
      meishoNm1: fields.whtankaNm!,
      b100180CreateFieldList,
    };

    B100180Create(param)
      .then(() => {
        setRows([]);
        methods.reset();
        tabMethods.reset();

        // ↓これがあると完了メッセージが表示される
        methods.setValue("whtankaCd", "");
        // 登録完了メッセージ表示
        setMsg(getClientMessage("B100180_001"));
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 更新
  const handleClickUpdateButton = () => {
    const fields = methods.getValues();

    // requestの作成
    const b100180UpdateFieldList = rows.map<B100180UpdateMeiRequest>(
      (value) => {
        const data: B100180UpdateMeiRequest = {
          height: value.height!,
          width1: value.width1,
          width2: value.width2,
          width3: value.width3,
          width4: value.width4,
          width5: value.width5,
          width6: value.width6,
          width7: value.width7,
          width8: value.width8,
          width9: value.width9,
          width10: value.width10,
          width11: value.width11,
          width12: value.width12,
          width13: value.width13,
          width14: value.width14,
          width15: value.width15,
          width16: value.width16,
          width17: value.width17,
          width18: value.width18,
          width19: value.width19,
          width20: value.width20,
          width21: value.width21,
          width22: value.width22,
          width23: value.width23,
          width24: value.width24,
          width25: value.width25,
          width26: value.width26,
          width27: value.width27,
          width28: value.width28,
          width29: value.width29,
          width30: value.width30,
          width31: value.width31,
          width32: value.width32,
          width33: value.width33,
          width34: value.width34,
          width35: value.width35,
          width36: value.width36,
          width37: value.width37,
          width38: value.width38,
          width39: value.width39,
          width40: value.width40,
          width41: value.width41,
          width42: value.width42,
          width43: value.width43,
          width44: value.width44,
          width45: value.width45,
          width46: value.width46,
          width47: value.width47,
          width48: value.width48,
          width49: value.width49,
          version: value.version!,
        };
        return data;
      }
    );
    const param: B100180UpdateRequest = {
      whtankaKbn: fields.whtankaKbn?.value!,
      whtankaCd: fields.whtankaCd!,
      b100180UpdateFieldList,
    };

    B100180Update(param)
      .then(() => {
        setRows([]);
        methods.reset();
        tabMethods.reset();

        // ↓これがあると完了メッセージが表示される
        methods.setValue("whtankaCd", "");
        // 更新完了メッセージ表示
        setMsg(getClientMessage("B100180_002"));
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 削除
  const handleClickDeleteButton = () => {
    const fields = methods.getValues();

    // 新規登録するデータの作成
    const b100180DeleteFieldList = rows.map<B100180DeleteMeiRequest>(
      (value) => {
        const data: B100180DeleteMeiRequest = {
          height: value.height!,
          version: value.version!.toString(),
        };
        return data;
      }
    );
    const param: B100180DeleteRequest = {
      whtankaKbn: fields.whtankaKbn?.value!,
      whtankaCd: fields.whtankaCd!,
      b100180DeleteFieldList,
    };

    B100180Delete(param)
      .then(() => {
        setRows([]);
        methods.reset();
        tabMethods.reset();

        // ↓これがあると完了メッセージが表示される
        methods.setValue("whtankaCd", "");
        // 削除完了メッセージ表示
        setMsg(getClientMessage("B100180_003"));
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // WH単価区分変更時
  const handleChangeWhtankaKbn = () => {
    // モード、WH単価区分以外をクリアする
    const { modeKbn, whtankaKbn } = methods.getValues();
    methods.reset();
    tabMethods.reset();
    methods.setValue("modeKbn", getSCode(B100180Mode, modeKbn!.value));
    methods.setValue(
      "whtankaKbn",
      getSCode(B100180WhTankaKbn, whtankaKbn!.value)
    );

    setRows([]);
    reRendering();
  };

  // WH単価変更
  const handleChangeWhtankaCd = () => {
    const fields = methods.getValues();
    if (fields.whtankaCd === fields.dirtyFields?.whtankaCd) {
      return;
    }

    // 空の場合クリア
    if (fields.whtankaCd === "") {
      methods.setValue("whtankaNm", "");
      setRows([]);
      return;
    }
    reRendering();

    // 検索
    handleFind();
  };

  // 参照コード変更
  const handleChangeSanshoWhtankaCd = () => {
    const fields = methods.getValues();
    if (fields.sanshoWhtankaCd === fields.dirtyFields?.sanshoWhtankaCd) {
      return;
    }

    // 空の場合クリア(明細はクリアしない)
    if (fields.whtankaCd === "") {
      methods.setValue("sanshoWhtankaNm", "");
      return;
    }
    reRendering();

    // 検索
    handleFindSansho();
  };

  // excelボタンクリック時
  const handleMoveOutput = () => {
    // WH単価マスタメンテ出力画面へ遷移する。
    setMenuNavigate("next");
    navigate("/b100183");
  };

  // WH単価照会ダイアログの引数を設定
  const [whtankaDialogProps, setWhtankaDialogProps] = useState<B000111Props>();
  const updateWhtankaDialogProps = () => {
    const fields = methods.getValues();
    let meishoKbnVal: string = "";
    if (fields.whtankaKbn?.value === whtankaKbnTanka) {
      meishoKbnVal = meishoKbn.whTanka;
    } else if (fields.whtankaKbn?.value === whtankaKbnGenka) {
      meishoKbnVal = meishoKbn.whGentanka;
    }

    setWhtankaDialogProps({
      meishoKbn: meishoKbnVal,
    });
    reRendering();
  };

  // 明細更新
  const handleClickUpdateMeiButton = () => {
    // フィールドチェック
    tabMethods.handleSubmit(() => {
      const gyoNo: number = rowData?.gyoNo!;
      // 明細に設定するデータを取得
      const data: Data = handleDataMapping(gyoNo);
      // 明細を設定
      rows[gyoNo - 1] = data;
      setRows([...rows]);

      // 明細クリア
      tabMethods.reset();
    })();
  };

  // 明細のデータマッピング
  const handleDataMapping = (gyoNo: number): Data => {
    // フォームのデータを取得する。
    const tabFields = tabMethods.getValues();
    const data: Data = {
      gyoNo,
      height: tabFields.height,
      width1: tabFields.width1,
      width2: tabFields.width2,
      width3: tabFields.width3,
      width4: tabFields.width4,
      width5: tabFields.width5,
      width6: tabFields.width6,
      width7: tabFields.width7,
      width8: tabFields.width8,
      width9: tabFields.width9,
      width10: tabFields.width10,
      width11: tabFields.width11,
      width12: tabFields.width12,
      width13: tabFields.width13,
      width14: tabFields.width14,
      width15: tabFields.width15,
      width16: tabFields.width16,
      width17: tabFields.width17,
      width18: tabFields.width18,
      width19: tabFields.width19,
      width20: tabFields.width20,
      width21: tabFields.width21,
      width22: tabFields.width22,
      width23: tabFields.width23,
      width24: tabFields.width24,
      width25: tabFields.width25,
      width26: tabFields.width26,
      width27: tabFields.width27,
      width28: tabFields.width28,
      width29: tabFields.width29,
      width30: tabFields.width30,
      width31: tabFields.width31,
      width32: tabFields.width32,
      width33: tabFields.width33,
      width34: tabFields.width34,
      width35: tabFields.width35,
      width36: tabFields.width36,
      width37: tabFields.width37,
      width38: tabFields.width38,
      width39: tabFields.width39,
      width40: tabFields.width40,
      width41: tabFields.width41,
      width42: tabFields.width42,
      width43: tabFields.width43,
      width44: tabFields.width44,
      width45: tabFields.width45,
      width46: tabFields.width46,
      width47: tabFields.width47,
      width48: tabFields.width48,
      width49: tabFields.width49,
      version: tabFields.version,
    };

    return data;
  };

  // テーブル行ダブルクリックイベント
  const handleDoubleClickTableRow = (rowData: Data) => {
    // 削除モードのときは編集不可
    if (isDel()) {
      return;
    }

    tabMethods.reset();
    // ダブルクリックした行を選択状態にする
    setRowData(rowData);
    // タブ部にデータを表示する。
    tabMethods.setValue("height", rowData.height);
    tabMethods.setValue("width1", rowData.width1);
    tabMethods.setValue("width2", rowData.width2);
    tabMethods.setValue("width3", rowData.width3);
    tabMethods.setValue("width4", rowData.width4);
    tabMethods.setValue("width5", rowData.width5);
    tabMethods.setValue("width6", rowData.width6);
    tabMethods.setValue("width7", rowData.width7);
    tabMethods.setValue("width8", rowData.width8);
    tabMethods.setValue("width9", rowData.width9);
    tabMethods.setValue("width10", rowData.width10);
    tabMethods.setValue("width11", rowData.width11);
    tabMethods.setValue("width12", rowData.width12);
    tabMethods.setValue("width13", rowData.width13);
    tabMethods.setValue("width14", rowData.width14);
    tabMethods.setValue("width15", rowData.width15);
    tabMethods.setValue("width16", rowData.width16);
    tabMethods.setValue("width17", rowData.width17);
    tabMethods.setValue("width18", rowData.width18);
    tabMethods.setValue("width19", rowData.width19);
    tabMethods.setValue("width20", rowData.width20);
    tabMethods.setValue("width21", rowData.width21);
    tabMethods.setValue("width22", rowData.width22);
    tabMethods.setValue("width23", rowData.width23);
    tabMethods.setValue("width24", rowData.width24);
    tabMethods.setValue("width25", rowData.width25);
    tabMethods.setValue("width26", rowData.width26);
    tabMethods.setValue("width27", rowData.width27);
    tabMethods.setValue("width28", rowData.width28);
    tabMethods.setValue("width29", rowData.width29);
    tabMethods.setValue("width30", rowData.width30);
    tabMethods.setValue("width31", rowData.width31);
    tabMethods.setValue("width32", rowData.width32);
    tabMethods.setValue("width33", rowData.width33);
    tabMethods.setValue("width34", rowData.width34);
    tabMethods.setValue("width35", rowData.width35);
    tabMethods.setValue("width36", rowData.width36);
    tabMethods.setValue("width37", rowData.width37);
    tabMethods.setValue("width38", rowData.width38);
    tabMethods.setValue("width39", rowData.width39);
    tabMethods.setValue("width40", rowData.width40);
    tabMethods.setValue("width41", rowData.width41);
    tabMethods.setValue("width42", rowData.width42);
    tabMethods.setValue("width43", rowData.width43);
    tabMethods.setValue("width44", rowData.width44);
    tabMethods.setValue("width45", rowData.width45);
    tabMethods.setValue("width46", rowData.width46);
    tabMethods.setValue("width47", rowData.width47);
    tabMethods.setValue("width48", rowData.width48);
    tabMethods.setValue("width49", rowData.width49);
    tabMethods.setValue("version", rowData.version);
  };

  // レイアウト設定
  return (
    <>
      <FormProvider {...methods}>
        <SFrame
          title="WH単価マスタメンテ"
          gridTemplateColumns="8rem 5rem 5rem 10rem 5rem 5rem 5rem 15rem  6rem 1fr"
        >
          <SLabel required gridColumn="1">
            モード
          </SLabel>
          <SCodeSelect
            name="modeKbn"
            label="モード"
            required
            options={B100180Mode}
            gridColumn="span 2"
            {...register(1)}
            onChange={() => handleChangeModeKbn()}
          />
          <SFileButton
            label={labels.buttons.excel}
            align="right"
            gridColumn="10"
            {...register(6)}
            onClick={handleMoveOutput}
          />

          <SLabel required gridColumn="1">
            WH単価区分
          </SLabel>
          <SCodeSelect
            name="whtankaKbn"
            label="WH単価区分"
            required
            options={B100180WhTankaKbn}
            gridColumn="span 2"
            {...register(2)}
            onChange={() => handleChangeWhtankaKbn()}
          />

          <SLabel gridColumn={1}>WH単価</SLabel>
          {isNew() ? (
            <SNumberField
              name="whtankaCd"
              size={4}
              onBlur={() => handleChangeWhtankaCd()}
              {...register(3)}
            />
          ) : (
            <SNumberField
              name="whtankaCd"
              size={4}
              code
              onClick={updateWhtankaDialogProps}
              dialog={<B000111 {...whtankaDialogProps} />}
              handleSubmit={(data: any) => {
                methods.setValue("whtankaCd", data?.meishoCd);
                methods.setValue("whtankaNm", data?.meishoNm1);
                reRendering();
                // 検索
                handleFind();
              }}
              onBlur={() => handleChangeWhtankaCd()}
              {...register(3)}
            />
          )}
          <STextField
            name="whtankaNm"
            size={20}
            disabled={!isNew()}
            {...register(4)}
            gridColumn="span 2"
          />

          <SLabel gridColumn={6}>参照コード</SLabel>
          <SNumberField
            name="sanshoWhtankaCd"
            size={4}
            code
            onClick={updateWhtankaDialogProps}
            dialog={<B000111 {...whtankaDialogProps} />}
            handleSubmit={(data: any) => {
              methods.setValue("sanshoWhtankaCd", data?.meishoCd);
              methods.setValue("sanshoWhtankaNm", data?.meishoNm1);
              reRendering();
              // 検索
              handleFindSansho();
            }}
            onBlur={() => handleChangeSanshoWhtankaCd()}
            {...register(5)}
            disabled={!isNew()}
          />
          <STextField name="sanshoWhtankaNm" disabled />
        </SFrame>
      </FormProvider>

      <SFrame>
        <STable
          keyName="gyoNo"
          data={rows}
          columns={columns}
          tableRef={tableRef}
          handleDoubleClick={handleDoubleClickTableRow}
          width={1200}
          height={360}
          pageSize={pageSize}
        />
      </SFrame>
      <FormProvider {...tabMethods}>
        <SFrame>
          <SFrame gridTemplateColumns="6rem 6rem 6rem 6rem 6rem 6rem 6rem 6rem 6rem 6rem 6rem">
            <SLabel>高さ\幅</SLabel>
            <SLabel>100</SLabel>
            <SLabel>150</SLabel>
            <SLabel>200</SLabel>
            <SLabel>250</SLabel>
            <SLabel>300</SLabel>
            <SLabel>350</SLabel>
            <SLabel>400</SLabel>
            <SLabel>450</SLabel>
            <SLabel>500</SLabel>
            <SLabel>550</SLabel>

            <SNumberField name="height" disabled />
            <SNumberField
              name="width1"
              size={9}
              disabled={isDel()}
              {...register(7)}
            />
            <SNumberField
              name="width2"
              size={9}
              disabled={isDel()}
              {...register(8)}
            />
            <SNumberField
              name="width3"
              size={9}
              disabled={isDel()}
              {...register(9)}
            />
            <SNumberField
              name="width4"
              size={9}
              disabled={isDel()}
              {...register(10)}
            />
            <SNumberField
              name="width5"
              size={9}
              disabled={isDel()}
              {...register(11)}
            />
            <SNumberField
              name="width6"
              size={9}
              disabled={isDel()}
              {...register(12)}
            />
            <SNumberField
              name="width7"
              size={9}
              disabled={isDel()}
              {...register(13)}
            />
            <SNumberField
              name="width8"
              size={9}
              disabled={isDel()}
              {...register(14)}
            />
            <SNumberField
              name="width9"
              size={9}
              disabled={isDel()}
              {...register(15)}
            />
            <SNumberField
              name="width10"
              size={9}
              disabled={isDel()}
              {...register(16)}
            />

            <Box></Box>

            <SLabel>600</SLabel>
            <SLabel>650</SLabel>
            <SLabel>700</SLabel>
            <SLabel>750</SLabel>
            <SLabel>800</SLabel>
            <SLabel>850</SLabel>
            <SLabel>900</SLabel>
            <SLabel>950</SLabel>
            <SLabel>1000</SLabel>
            <SLabel>1050</SLabel>

            <Box></Box>

            <SNumberField
              name="width11"
              size={9}
              disabled={isDel()}
              {...register(17)}
            />
            <SNumberField
              name="width12"
              size={9}
              disabled={isDel()}
              {...register(18)}
            />
            <SNumberField
              name="width13"
              size={9}
              disabled={isDel()}
              {...register(19)}
            />
            <SNumberField
              name="width14"
              size={9}
              disabled={isDel()}
              {...register(20)}
            />
            <SNumberField
              name="width15"
              size={9}
              disabled={isDel()}
              {...register(21)}
            />
            <SNumberField
              name="width16"
              size={9}
              disabled={isDel()}
              {...register(22)}
            />
            <SNumberField
              name="width17"
              size={9}
              disabled={isDel()}
              {...register(23)}
            />
            <SNumberField
              name="width18"
              size={9}
              disabled={isDel()}
              {...register(24)}
            />
            <SNumberField
              name="width19"
              size={9}
              disabled={isDel()}
              {...register(25)}
            />
            <SNumberField
              name="width20"
              size={9}
              disabled={isDel()}
              {...register(26)}
            />

            <Box></Box>

            <SLabel>1100</SLabel>
            <SLabel>1150</SLabel>
            <SLabel>1200</SLabel>
            <SLabel>1250</SLabel>
            <SLabel>1300</SLabel>
            <SLabel>1350</SLabel>
            <SLabel>1400</SLabel>
            <SLabel>1450</SLabel>
            <SLabel>1500</SLabel>
            <SLabel>1550</SLabel>

            <Box></Box>

            <SNumberField
              name="width21"
              size={9}
              disabled={isDel()}
              {...register(27)}
            />
            <SNumberField
              name="width22"
              size={9}
              disabled={isDel()}
              {...register(28)}
            />
            <SNumberField
              name="width23"
              size={9}
              disabled={isDel()}
              {...register(29)}
            />
            <SNumberField
              name="width24"
              size={9}
              disabled={isDel()}
              {...register(30)}
            />
            <SNumberField
              name="width25"
              size={9}
              disabled={isDel()}
              {...register(31)}
            />
            <SNumberField
              name="width26"
              size={9}
              disabled={isDel()}
              {...register(32)}
            />
            <SNumberField
              name="width27"
              size={9}
              disabled={isDel()}
              {...register(33)}
            />
            <SNumberField
              name="width28"
              size={9}
              disabled={isDel()}
              {...register(34)}
            />
            <SNumberField
              name="width29"
              size={9}
              disabled={isDel()}
              {...register(35)}
            />
            <SNumberField
              name="width30"
              size={9}
              disabled={isDel()}
              {...register(36)}
            />

            <Box></Box>

            <SLabel>1600</SLabel>
            <SLabel>1650</SLabel>
            <SLabel>1700</SLabel>
            <SLabel>1750</SLabel>
            <SLabel>1800</SLabel>
            <SLabel>1850</SLabel>
            <SLabel>1900</SLabel>
            <SLabel>1950</SLabel>
            <SLabel>2000</SLabel>
            <SLabel>2050</SLabel>

            <Box></Box>

            <SNumberField
              name="width31"
              size={9}
              disabled={isDel()}
              {...register(37)}
            />
            <SNumberField
              name="width32"
              size={9}
              disabled={isDel()}
              {...register(38)}
            />
            <SNumberField
              name="width33"
              size={9}
              disabled={isDel()}
              {...register(39)}
            />
            <SNumberField
              name="width34"
              size={9}
              disabled={isDel()}
              {...register(40)}
            />
            <SNumberField
              name="width35"
              size={9}
              disabled={isDel()}
              {...register(41)}
            />
            <SNumberField
              name="width36"
              size={9}
              disabled={isDel()}
              {...register(42)}
            />
            <SNumberField
              name="width37"
              size={9}
              disabled={isDel()}
              {...register(43)}
            />
            <SNumberField
              name="width38"
              size={9}
              disabled={isDel()}
              {...register(44)}
            />
            <SNumberField
              name="width39"
              size={9}
              disabled={isDel()}
              {...register(45)}
            />
            <SNumberField
              name="width40"
              size={9}
              disabled={isDel()}
              {...register(46)}
            />

            <Box></Box>

            <SLabel>2100</SLabel>
            <SLabel>2150</SLabel>
            <SLabel>2200</SLabel>
            <SLabel>2250</SLabel>
            <SLabel>2300</SLabel>
            <SLabel>2350</SLabel>
            <SLabel>2400</SLabel>
            <SLabel>2450</SLabel>
            <SLabel>2500</SLabel>

            <Box></Box>
            <Box></Box>

            <SNumberField
              name="width41"
              size={9}
              disabled={isDel()}
              {...register(47)}
            />
            <SNumberField
              name="width42"
              size={9}
              disabled={isDel()}
              {...register(48)}
            />
            <SNumberField
              name="width43"
              size={9}
              disabled={isDel()}
              {...register(49)}
            />
            <SNumberField
              name="width44"
              size={9}
              disabled={isDel()}
              {...register(50)}
            />
            <SNumberField
              name="width45"
              size={9}
              disabled={isDel()}
              {...register(51)}
            />
            <SNumberField
              name="width46"
              size={9}
              disabled={isDel()}
              {...register(52)}
            />
            <SNumberField
              name="width47"
              size={9}
              disabled={isDel()}
              {...register(53)}
            />
            <SNumberField
              name="width48"
              size={9}
              disabled={isDel()}
              {...register(54)}
            />
            <SNumberField
              name="width49"
              size={9}
              disabled={isDel()}
              {...register(55)}
            />

            <SNormalButton
              label={labels.buttons.updateDetail}
              {...register(56)}
              gridRow="10"
              gridColumn="11"
              align="right"
              onClick={handleClickUpdateMeiButton}
              disabled={isDel()}
            />
          </SFrame>
        </SFrame>
      </FormProvider>
      <SFrame gridTemplateColumns="7rem 1fr">
        <SCancelButton
          label={labels.buttons.delete}
          gridColumn={1}
          {...register(57)}
          disabled={!isDel()}
          dialog={
            <SConfirmDialog
              title={labels.dialog.createMasterTitle}
              msg={labels.dialog.deleteConfirm}
            />
          }
          dialogAction="confirm"
          handleSubmit={handleClickDeleteButton}
        />

        {isNew() ? (
          <SNormalButton
            label={labels.buttons.create}
            align="right"
            {...register(58)}
            dialog={
              <SConfirmDialog
                title={labels.dialog.createMasterTitle}
                msg={labels.dialog.createConfirm}
              />
            }
            dialogAction="confirm"
            handleSubmit={handleClickCreateButton}
          />
        ) : (
          <SNormalButton
            label={labels.buttons.update}
            align="right"
            {...register(59)}
            dialog={
              <SConfirmDialog
                title={labels.dialog.createMasterTitle}
                msg={labels.dialog.updateConfirm}
              />
            }
            dialogAction="confirm"
            handleSubmit={handleClickUpdateButton}
            disabled={!isEdit()}
          />
        )}
      </SFrame>
    </>
  );
};
